import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteUnitDialogProps {
  /** Whether the dialog is open */
  open: boolean
  /** Unit code being deleted */
  unitCode: string
  /** Called when open state changes */
  onOpenChange: (open: boolean) => void
  /** Called when delete is confirmed */
  onConfirm: () => void
  /** Whether delete operation is in progress */
  isDeleting: boolean
}

/**
 * Confirmation dialog for deleting a unit
 */
export function DeleteUnitDialog({
  open,
  unitCode,
  onOpenChange,
  onConfirm,
  isDeleting,
}: DeleteUnitDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Unit</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete unit <strong>"{unitCode}"</strong>?
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
